import React, { useState } from "react";

import "./features/phone/main.less";
import { PhoneStep } from "./features/phone/PhoneStep";
import { OtpStep } from "./features/phone/OtpStep";
import { GiftcardStep } from "./features/phone/GiftcardStep";

type Step = "phone" | "otp" | "giftcard";

export const App = () => {
  const [step, setStep] = useState<Step>("phone");
  const [phone, setPhone] = useState("");

  return (
    <div className="app">
      <section className="phone-flow">
        <header className="phone-flow__header">
          <img src="/favicon.svg" alt="" width={48} height={48} />
        </header>
        {step === "phone" && (
          <PhoneStep
            onRequested={(enteredPhone) => {
              setPhone(enteredPhone);
              setStep("otp");
            }}
          />
        )}
        {step === "otp" && (
          <OtpStep
            phone={phone}
            onVerified={() => setStep("giftcard")}
            onStartOver={() => setStep("phone")}
          />
        )}
        {step === "giftcard" && <GiftcardStep />}
      </section>
    </div>
  );
};
